import type { Metadata } from "next";
import Category from "@/Component/Admin/Category";

export const metadata: Metadata = {
    title: "Categories | Connector Club",
    description: "",
};

const CategoryPage = () => {
    return (
        <Category />
    );
}

export default CategoryPage;
